import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { getJobPostList, getJobPostDetails } from "../../../../redux/jobpost/jobPostState";
import { doApplyJob } from "../../../../redux/jobapplicant/jobApplicantState";
import { useParams, useNavigate } from "react-router-dom";
import JobPositionCard from "./JobPositionCard";
import JobDescription from "./JobDescription";
import { ArrowLeft } from "lucide-react";
import HeaderComponent from "components/card/HeaderComponent";
import HyvidAdCard from "./HyvidAdCard";
import HyvidReferralCard from "./HyvidReferralCard";
import HyvidApply from "./HyvidApply";
import cookie from 'js-cookie';
import { Modal  } from 'antd';
import Button from "components/button";

const JobPostDetails = ({ 
  recordId, 
  recordList, 
  doSearch,
  filters, 
  getRecord,
  recordData,
  authUser,
  submitApplication,
}) => {
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);

    useEffect(() => {
      if (filters) {
        doSearch(filters);
      }
    }, [filters, doSearch]);

  const [selectedJobId, setSelectedJobId] = useState(recordId);

    useEffect(() => {
      console.log(authUser);
        getRecord({id:selectedJobId, userId: authUser ? authUser.id : 0});
    }, [getRecord, selectedJobId]);

  const onClickApply = () => {
    if(authUser){
      if(authUser.resume_submitted){
        submitApplication(selectedJobId);
      }else{
        setOpen(true);
      }
      
    }else{
      cookie.set('redirect_after_login', `/job-posts/${selectedJobId}/view`);
      navigate(`/auth/sign-in`);
    }
  }

  const onProceedHandler = () => {
    cookie.set('redirect_after_login', `/job-posts/${selectedJobId}/view`);
    navigate(`/my/profile/${authUser?.user_detail?.ude_id}/edit`);
  }

  return (
    <div className="grid grid-cols-4 gap-6">
      <div className="col-span-1">
        <HeaderComponent
          title="All Open Positions"
          titleClass="font-medium text-lg"
          description={`${recordList?.length} jobs available`}
          descriptionClass="text-xs text-gray-700"
          cardBorder="border-2 border-purple-100 max-h-[calc(100vh-7rem)] overflow-y-auto sticky top-24" 
        >
          <div className="space-y-2">
            <JobPositionCard
                data={recordList}
                selectedId={selectedJobId}
                onSelect={(postId) => {
                    setSelectedJobId(postId); 
                }}
            />
          </div>
        </HeaderComponent>
      </div>

      <div className="col-span-3 px-5 gradient-effect space-y-4">
        <button
          onClick={() => navigate("/job-posts")}
          className="inline-flex items-center justify-center gap-2 rounded-md text-sm font-medium 
                     focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] 
                     h-9 px-4 py-2 mb-2 hover:bg-purple-50 border border-purple-200 bg-white"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to all jobs
        </button>

        <JobDescription onApplyHandler={onClickApply}/>
        <HyvidAdCard/>
        { !recordData?.already_applied &&
          <HyvidApply onApplyHandler={onClickApply}/>
        }
      </div>

      <Modal
        className="custom-ant-modal-content"
        open={open}
        closeIcon={false}
        centered
        title={<h2 className="popup-modal-title">Requirements</h2>}
        okText="Confirm"
        cancelText="Cancel"
        footer={(_) => (
            <div className="flex w-full justify-end p-3 gap-5">
                <Button className="icon-effect px-5 py-2 font-semibold" 
                    onClick={() => {setOpen(false)}}
                >
                    Cancel
                </Button>
                <Button className="icon-effect gradient-primary px-5 py-2 font-semibold" 
                    onClick={onProceedHandler}
                >
                    Proceed to Upload
                </Button>
            </div>
        )}
        >
            <div className='content-wrapper text-lg text-center px-10'>
                You need to upload your resume before you can apply to any job post.
            </div>
        </Modal>

    </div>
  );
};


const mapStateToProps = (state) => ({
  recordList: state.jobPost.jobPostList?.items,
  filters: state.jobPost.jobPostList?.filters,
  requesting: state.jobPost.jobPostList?.requesting,
  error: state.jobPost.jobPostList?.error,
  recordData: state.jobPost.jobPostDetails.data,
  authUser: state.auth.user,
});

const mapDispatchToProps = (dispatch) => ({
  doSearch: (filters) => dispatch(getJobPostList(filters)),
  getRecord: (data) => dispatch(getJobPostDetails(data)),
  submitApplication: (id) => dispatch(doApplyJob(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(JobPostDetails);
